var exports = {
  "q5": "AppLayout.module__appLayout___aE1vbl",
  "Xp": "AppLayout.module__appLayoutStandalone___aE1vbl",
  "PQ": "AppLayout.module__appLayoutWithBar___aE1vbl",
};

module.exports = exports;
